import { ScrollableButtons } from '@app/components/scrollable-buttons';

const departmentScrollId = 'departments-scroll';

document.addEventListener('DOMContentLoaded', () => {
    (<any>window).scrollableButtons = new ScrollableButtons(departmentScrollId);
});

/**
 * Runs after HTMX has loaded new content onto the page.
 */
document.addEventListener('htmx:afterSettle', (event: any) => {
    // do nothing if the update is not for the department buttons
    if (event?.detail.target.id !== 'dynamic-content') {
        return;
    }

    // the previous buttons were removed by HTMX, the event handlers have to be removed and then new ones created for
    // the new buttons
    (<any>window).scrollableButtons.destroy();
    (<any>window).scrollableButtons = new ScrollableButtons(departmentScrollId);
});
